import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useStore = create(
  persist(
    (set, get) => ({
      // Selected keys for practice
      selectedKeys: ['C', 'G', 'D', 'A', 'F'],
      setSelectedKeys: (keys) => set({ selectedKeys: keys }),
      toggleKey: (key) => {
        const current = get().selectedKeys;
        if (current.includes(key)) {
          if (current.length > 1) {
            set({ selectedKeys: current.filter(k => k !== key) });
          }
        } else {
          set({ selectedKeys: [...current, key] });
        }
      },

      // Practice mode
      practiceMode: 'number_to_chord', // 'number_to_chord' or 'chord_to_number'
      setPracticeMode: (mode) => set({ practiceMode: mode }),

      // Session stats
      sessionStats: {
        correct: 0,
        incorrect: 0,
        streak: 0,
        bestStreak: 0,
        startTime: null,
        questionsAnswered: 0
      },
      resetSession: () => set({
        sessionStats: {
          correct: 0,
          incorrect: 0,
          streak: 0,
          bestStreak: 0,
          startTime: Date.now(),
          questionsAnswered: 0
        }
      }),
      recordAnswer: (isCorrect) => {
        const stats = get().sessionStats;
        const newStreak = isCorrect ? stats.streak + 1 : 0;
        set({
          sessionStats: {
            ...stats,
            correct: isCorrect ? stats.correct + 1 : stats.correct,
            incorrect: isCorrect ? stats.incorrect : stats.incorrect + 1,
            streak: newStreak,
            bestStreak: Math.max(stats.bestStreak, newStreak),
            questionsAnswered: stats.questionsAnswered + 1
          }
        });
      },

      // Timer settings
      timerEnabled: false,
      timerDuration: 10, // seconds per question
      setTimerEnabled: (enabled) => set({ timerEnabled: enabled }),
      setTimerDuration: (duration) => set({ timerDuration: duration }),

      // Dark mode
      darkMode: false,
      toggleDarkMode: () => set(state => ({ darkMode: !state.darkMode })),

      // Sound effects
      soundEnabled: true,
      toggleSound: () => set(state => ({ soundEnabled: !state.soundEnabled })),
    }),
    {
      name: 'nashville-numbers-storage',
      partialize: (state) => ({
        selectedKeys: state.selectedKeys,
        practiceMode: state.practiceMode,
        timerEnabled: state.timerEnabled,
        timerDuration: state.timerDuration,
        darkMode: state.darkMode,
        soundEnabled: state.soundEnabled,
      }),
    }
  )
);

export default useStore;
